export default [
  {
    formFields: [
      {
        title: 'Floor name',
        type: 'text',
        property: 'name',
        value: '',
        counter: 50,
        rules: [(v) => !!v || 'Floor name is required', (v) => v.length <= 50 || 'Max 50 characters'],
        required: true,
        autofocus: false
      },
      {
        title: 'Short description',
        type: 'textarea',
        property: 'description',
        noResize: true,
        rows: 3,
        required: false,
        value: '',
        counter: 120,
        rules: [(v) => !!v && v.length <= 120 || 'Max 120 characters']
      },
      {
        title: 'Floor theme',
        type: 'select',
        property: 'variant',
        items: ['Modern', 'Nature', 'Automotive', 'Tech'],
        value: [],
        rules: []
      },
    ]
  }
];
